import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { Box, Button, CircularProgress } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../features/defaultSlice";
import { downloadReport, getJobsData } from "../../features/jobs/jobs";
import { getRole, Roles } from "../../utils/helper";

function ViewRejectionReason({ data, isCorporate }) {
  const { modal } = useSelector(getJobsData);
  const dispatch = useDispatch();

  return (
    <Box>
      <div className="flex justify-between flex-wrap w-full">
        <p className="font-[600]">Banks' Comment</p>
        <p>
          {data?.VendorJobLedgers?.[0]?.Comment ||
            data?.CorporateVendorJobLedgers?.[0]?.Comment ||
            "Not Available"}
        </p>
      </div>
      <br />
      <div className="flex justify-between w-full">
        <p className="font-[600]">Banks' Report</p>

        {isCorporate ? (
          data?.CorporateJobRejections?.[0]?.BankRejectionImages?.[0] ? (
            <button
              onClick={() =>
                dispatch(
                  downloadReport(
                    data?.CorporateJobRejections?.[0]?.BankRejectionImages?.[0]
                  )
                )
              }
              className="mt-2 flex items-end"
              type="button"
              disabled={modal.loader.download}
            >
              <CloudDownloadIcon color="error" />
              <span className="text-[#D70900] ml-1">
                {" "}
                {modal.loader.download ? "Downloading..." : "Download file"}
              </span>
              {modal.loader.download && (
                <CircularProgress
                  size="15px"
                  sx={{ color: "#D70900", margin: "5px" }}
                />
              )}
            </button>
          ) : (
            <p>Not Available</p>
          )
        ) : // CAV REJECTION PART
        data?.JobRejections?.[0]?.BankRejectionImages?.[0] ? (
          <button
            onClick={() =>
              dispatch(
                downloadReport(
                  data?.JobRejections?.[0]?.BankRejectionImages?.[0]
                )
              )
            }
            className="mt-2 flex items-end"
            type="button"
            disabled={modal.loader.download}
          >
            <CloudDownloadIcon color="error" />
            <span className="text-[#D70900] ml-1">
              {" "}
              {modal.loader.download ? "Downloading..." : "Download file"}
            </span>
            {modal.loader.download && (
              <CircularProgress
                size="15px"
                sx={{ color: "#D70900", margin: "5px" }}
              />
            )}
          </button>
        ) : (
          <p>Not Available</p>
        )}
      </div>
      {Roles.vendor === getRole() && (
        <>
          <br />
          <Button
            onClick={() => dispatch(openModal("new"))}
            variant="contained"
            color="error"
            className="capitalize"
            style={{ textTransform: "capitalize" }}
          >
            Revalidate
          </Button>
        </>
      )}
    </Box>
  );
}

export default ViewRejectionReason;
